<script lang="ts" module>
  import { Checkbox, Label } from 'bits-ui';
  import { tv } from 'tailwind-variants';

  import Icon from '@/ui/base/icon/Icon.svelte';

  export type CheckboxItem = {
    id: number;
    label?: string;
    checked?: boolean;
  };

  export interface CheckboxProps {
    item: CheckboxItem;
    onChecked?: (item: CheckboxItem) => void;
  }
</script>

<script lang="ts">
  let { ...props }: CheckboxProps = $props();

  let checkedProp: boolean = $state(props.item.checked ?? false);

  const styles = tv({
    base: 'mr-2 rounded-sm  p-1',
    variants: {
      checked: {
        true: 'bg-success',
        false: 'bg-neutral',
      },
    },
  });
</script>

<div class="flex items-center">
  <Checkbox.Root
    checked={checkedProp}
    id="terms"
    aria-labelledby="terms-label"
    class={styles({ checked: checkedProp })}
    name="hello"
    onCheckedChange={(cc) => {
      checkedProp = cc;
      props.onChecked?.({ ...props.item, checked: cc });
    }}
  >
    <div class="size-4 items-center justify-center">
      {#if checkedProp}
        <Icon icon="Done" class="size-4"></Icon>
      {/if}
    </div>
  </Checkbox.Root>
  {#if props.item.label}
    <Label.Root id="terms-label" for="terms" class="font-sans text-sm font-normal text-c"
      >{props.item.label}</Label.Root
    >
  {/if}
</div>
